<mat-tab-group
  [selectedIndex]="selectedIndex()"
  (selectedIndexChange)="selectedIndexChange($event)"
>
  <ng-container *ngFor="let tab of tabs(); let i = index">
    <mat-tab [label]="tab.label">
      <ng-template mat-tab-label>
        <span
          class="font-edenred font-bold text-2xl"
          [ngClass]="
            selectedIndex() === i
              ? 'text-grayscale-black'
              : 'text-grayscale-heavy'
          "
        >
          {{ tab.label | transloco }}
        </span>
      </ng-template>
      <ng-container *ngComponentOutlet="tab.component || null"></ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>
